import { Popover as ChakraPopover, Portal } from '@chakra-ui/react'
import { mdiInformation, mdiInformationOutline } from '@mdi/js'
import Icon from '@mdi/react'
import * as React from 'react'
import { forwardRef, useState } from 'react'

import { IconButton } from './button'

export interface IToggleTipProps extends ChakraPopover.RootProps {
    showArrow?: boolean
    portalled?: boolean
    portalRef?: React.RefObject<HTMLElement>
    content?: React.ReactNode
    contentProps?: ChakraPopover.ContentProps
}

const DEFAULT_ICON = (
    <span>
        <Icon path={mdiInformation} size="16px" color="var(--chakra-colors-gray-500)" />
    </span>
)

const DEFAULT_ICON_ACTIVE = (
    <span>
        <Icon path={mdiInformationOutline} size="16px" color="var(--chakra-colors-gray-500)" />
    </span>
)

export const ToggleTip = forwardRef<HTMLDivElement, IToggleTipProps>(function ToggleTip(props, ref) {
    const { showArrow, children, portalled = true, content, portalRef, contentProps, variant = 'gsk', ...rest } = props

    return (
        <ChakraPopover.Root {...rest} positioning={{ ...rest.positioning }} variant={variant}>
            <ChakraPopover.Trigger asChild>{children}</ChakraPopover.Trigger>
            <Portal disabled={!portalled} container={portalRef}>
                <ChakraPopover.Positioner>
                    <ChakraPopover.Content {...contentProps} ref={ref}>
                        {showArrow && (
                            <ChakraPopover.Arrow>
                                <ChakraPopover.ArrowTip />
                            </ChakraPopover.Arrow>
                        )}
                        {content}
                    </ChakraPopover.Content>
                </ChakraPopover.Positioner>
            </Portal>
        </ChakraPopover.Root>
    )
})

export const InfoTip = React.forwardRef<HTMLDivElement, Partial<IToggleTipProps>>(function InfoTip(props, ref) {
    const { children, ...rest } = props
    const [open, setOpen] = useState(rest.defaultOpen)
    const handleOpenChange: NonNullable<IToggleTipProps['onOpenChange']> = (details) => {
        setOpen(details.open)
        props.onOpenChange?.(details)
    }

    return (
        <ToggleTip content={children} {...rest} ref={ref} onOpenChange={handleOpenChange}>
            {children ?? <IconButton variant="tooltipIcon">{open ? DEFAULT_ICON : DEFAULT_ICON_ACTIVE}</IconButton>}
        </ToggleTip>
    )
})
